export const savingAdjustmentSelector = ({ provision }) => provision.adjustments.savingAdjustment;
export const accountsFetchingSelector = ({ provision }) => provision.adjustments.accountsFetching;
export const accountsSelector = ({ provision }) => provision.adjustments.accounts;
export const fetchingInitialDataForAdjustmentModalSelector = ({ provision }) =>
  provision.adjustments.fetchingInitialDataForAdjustmentModal;
export const fetchingAttachmentsSelector = ({ provision }) => provision.adjustments.fetchingAttachments;
export const attachmentsSelector = ({ provision }) => provision.adjustments.adjustmentAttachments;
export const isRemovingInProgressSelector = ({ provision }) => provision.adjustments.removingAdjustment;
